import React from "react";
import "./Privacy.scss";
import { Button, Col, Divider, Input, Radio, Row } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import SearchSetting from "@components/SearchSetting/SearchSetting";

const Privacy: React.FC = () => {
  return (
    <div className="Privacy">
      <SearchSetting />
      <div className="title">Privacy</div>

      <Row>
        <Col flex="auto" className="privacy-group">
          <p> </p>
          <span className="group-title">Ratings and Reviews</span>
          <div className="privacy-item">
            <span className="privacy-name">Ratings</span>
          </div>
          <div className="privacy-item">
            <span className="privacy-name">Reviews</span>
          </div>

          <span className="group-title">Producer Hub</span>
          <div className="privacy-item">
            <span className="privacy-name">Badges</span>
          </div>
          <div className="privacy-item">
            <span className="privacy-name">Achievements</span>
          </div>
          <div className="privacy-item">
            <span className="privacy-name">Producer Hub - Feedback</span>
          </div>
          <div className="privacy-item">
            <span className="privacy-name">
              Producer Hub - Buyers Purchasing
            </span>
          </div>
          <div className="privacy-item">
            <span className="privacy-name">Ranking Updates</span>
          </div>

          <Divider />

          <div className="privacy-group">
            <span className="group-title">Chat</span>
            <div className="privacy-item">
              <span className="privacy-name">Allow Private Messaging</span>
            </div>
          </div>
        </Col>

        <Col flex="135px" className="status-group">
          <div className="status-item">
            <p>Shown</p>
            <p>Hidden</p>
          </div>
          <p> </p>
          <Radio.Group className="status-item" defaultValue="shown">
            <Radio value={"shown"}></Radio>
            <Radio value={"hidden"}></Radio>
          </Radio.Group>
          <Radio.Group className="status-item" defaultValue="shown">
            <Radio value={"shown"}></Radio>
            <Radio value={"hidden"}></Radio>
          </Radio.Group>

          <div className="status-item">
            <p> </p>
            <p> </p>
          </div>
          <Radio.Group className="status-item" defaultValue="shown">
            <Radio value={"shown"}></Radio>
            <Radio value={"hidden"}></Radio>
          </Radio.Group>
          <Radio.Group className="status-item" defaultValue="shown">
            <Radio value={"shown"}></Radio>
            <Radio value={"hidden"}></Radio>
          </Radio.Group>
          <Radio.Group className="status-item" defaultValue="shown">
            <Radio value={"shown"}></Radio>
            <Radio value={"hidden"}></Radio>
          </Radio.Group>
          <Radio.Group className="status-item" defaultValue="shown">
            <Radio value={"shown"}></Radio>
            <Radio value={"hidden"}></Radio>
          </Radio.Group>
          <Radio.Group className="status-item" defaultValue="shown">
            <Radio value={"shown"}></Radio>
            <Radio value={"hidden"}></Radio>
          </Radio.Group>

          <Divider />

          <div className="status-item">
            <p>Yes</p>
            <p>No</p>
          </div>
          <Radio.Group className="status-item" defaultValue="shown">
            <Radio value={"shown"}></Radio>
            <Radio value={"hidden"}></Radio>
          </Radio.Group>
        </Col>
      </Row>

      <div className="btn-group">
        <Button className="save-btn">Save</Button>
      </div>
    </div>
  );
};

export default Privacy;
